/**
 * @generated SignedSource<<45d72742b2bf1b38ef3344a58ec97396>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueBodyViewerPinnedComment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PinnedCommentDisplay">;
  readonly " $fragmentType": "IssueBodyViewerPinnedComment";
};
export type IssueBodyViewerPinnedComment$key = {
  readonly " $data"?: IssueBodyViewerPinnedComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyViewerPinnedComment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyViewerPinnedComment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PinnedCommentDisplay"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "6cc94f989c57261cf27eb268015259d0";

export default node;
